export default {
  checkreturn: {
    searchPlaceholder: '请输入商品名或验退单号或供应商查询',
    checkReturnNo: '验退单号',
    checkReturnDate: '验退日期',
    purOfficeNo: '采购中心',
    supOfficeNo: '供应商',
    orderType: '订单性质',
    payTermsName: '付款条件',
    txTermsName: '交易条件',
    currencyName: '币种',
    exchangeRate: '汇率',
    tranConditonName: '交易条件',
    invoiceTypeName: '发票类型',
    checkReturnSeq: '项次-项序-分批序',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    checkReturnQty: '验退数量',
    purUnitName: '单位',
    outCheckReturnNo: '外部单号',
    checkReturnReason: '验退原因',
    purchaseUnitNo: '采购中心',
    dateRange: '验退日期'
  },
  returndetails: {
    searchPlaceholder: '输入商品名或退货单号或供应商进行搜索',
    returnNo: '退货单号',
    docDate: '退货日期',
    purOfficeName: '采购中心',
    purchaseUnitName: '采购中心',
    supplierName: '供应商',
    orderType: '订单性质',
    payTermsName: '付款条件',
    txTermsName: '交易条件',
    currencyName: '币种',
    tranConditonName: '交易条件',
    exchangeRate: '汇率',
    invoiceTypeName: '发票类型',
    returnSeq: '项次',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    returnQty: '退货数量',
    purchaseReturnQty: '退货数量',
    valuationQty: '计价数量',
    purUnitName: '单位',
    unitPrice: '含税单价',
    preTaxAmount: '税前金额',
    taxIncludedAmount: '含税金额',
    taxAmount: '税额',
    taxTypeName: '税种',
    taxRateBody: '税率',
    taxRate: '汇率',
    sanlian: '项次-项序-分批序',
    purchaseNo: '订单单号',
    purchaseSeq: '订单项次',
    purchasePhaseSeq: '订单项序',
    outReturnNo: '外部单号',
    returnReason: '退货原因',
    purchaseUnitNo: '采购中心',
    dateRange: '退货日期'
  }
}
